module.exports = __webpack_public_path__ + "img/BCP.5f47071.png";